import React, { useEffect, useState } from 'react';
import EmptySynthesisLogo from '../assets/img/ai-platform-unified-svgrepo-com.svg';
import EmptyPrompt from './EmptyPrompt';
import { Box, Text, Container } from '@mantine/core';
import { theme } from '../consilitheme';
import { useGetSynthesisQuery } from '../endpoints/synthesis';
import SynthesisItem from './SynthesisItem';
import { Accordion } from '@mantine/core';
import ReactSearchBox from 'react-search-box';
import Fuse from 'fuse.js';

const SynthesisManager = () => {
  const { data } = useGetSynthesisQuery();
  const [synthesisData, setSynthesisData] = useState([]);
  const [searchInput, setSearchInput] = useState('');
  const showEmptyDataPrompt =
    (!synthesisData || !synthesisData?.length) && !searchInput;
  const showEmptySeachResults =
    (!synthesisData || !synthesisData?.length) && searchInput;
  const defaultValue = synthesisData?.length
    ? `${synthesisData[0]?.created}-${synthesisData[0]?.id}`
    : undefined;

  useEffect(() => {
    if (data) {
      setSynthesisData(data);
    }
  }, [data]);

  const filterSynthesis = (input) => {
    setSearchInput(input);
    const fuse = new Fuse(data, {
      shouldSort: true,
      keys: ['title', 'summary', 'created'],
    });
    const result = fuse.search(input);
    const finalResult = result.length ? result.map((item) => item.item) : data;
    setSynthesisData(finalResult);
  };

  return (
    <Container>
      <Text
        fw={700}
        className="panel-title"
        mb={theme.padding.sm}
        pt={theme.padding.md}
      >
        Information Synthesis
      </Text>
      {!showEmptyDataPrompt && (
        <Box style={{ height: '60px', overflow: 'hidden' }}>
          <ReactSearchBox
            placeholder={
              searchInput.length ? searchInput : 'Search for a synthesis...'
            }
            data={synthesisData?.map((synthesis) => ({
              ...synthesis,
              key: synthesis.id,
              value: synthesis.s3_path,
            }))}
            onChange={(input) => filterSynthesis(input)}
            inputFontSize={700}
            inputHeight={75}
            clearOnSelect={false}
          />
        </Box>
      )}
      {showEmptyDataPrompt && (
        <EmptyPrompt
          svgLink={EmptySynthesisLogo}
          description="Consili is synthesizing your data. You’ll be notified of any new developments"
        />
      )}
      <Accordion
        chevronPosition="right"
        variant="contained"
        defaultValue={defaultValue}
      >
        {showEmptySeachResults && (
          <EmptyPrompt
            svgLink={EmptySynthesisLogo}
            description="No syntheses were found with your search parameters"
          />
        )}
        <Accordion
          chevronPosition="right"
          variant="contained"
          defaultValue={defaultValue}
        ></Accordion>
        {synthesisData &&
          synthesisData.map((synthesis) => (
            <Accordion.Item
              key={synthesis.id}
              value={`${synthesis.id}-${synthesis.created}`}
              mb={5}
              style={{ borderColor: 'transparent' }}
            >
              <SynthesisItem synthesis={synthesis} key={synthesis.id} />
            </Accordion.Item>
          ))}
      </Accordion>
    </Container>
  );
};

export default SynthesisManager;
